<template>
  <div class="ml-5 p-5 border border-danger bg-danger/10 text-danger w-[420px]">
    <p class="text-sm font-semibold mb-1">
      This municipality has been archived
    </p>

    <p class="mb-0 text-xs leading-[17px]">
      You cannot make changes to this document as the municipality has been archived.
      If you would like to make changes the municipality would have to be restored.
    </p>
  </div>
</template>
